// extracted by mini-css-extract-plugin
export var brand = "Footer-module--brand--1d22b";
export var columnTitle = "Footer-module--columnTitle--80130";
export var footer = "Footer-module--footer--afd90";
export var footerGrid = "Footer-module--footerGrid--16530";
export var footnote = "Footer-module--footnote--6bf73";
export var link = "Footer-module--link--8b124";
export var positioning = "Footer-module--positioning--ecfdf";
export var social = "Footer-module--social--e1ae8";